import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "h-[76px] relative" }
const _hoisted_4 = { class: "absolute left-0 right-0 -bottom-[55px] -ml-[33px] md:-ml-[37px] -mr-[30px] md:-mr-[35px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "trezo-card-header mb-[20px] flex items-center justify-between" }, [
      _createElementVNode("div", { class: "trezo-card-title flex items-center gap-[10px]" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Instagram Campaigns"),
        _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-orange-100 dark:bg-[#15203c] text-orange-600 rounded-sm font-medium text-xs" }, " Live Now ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"flex items-center gap-[25px]\"><div><div class=\"flex items-center gap-[5px] mb-[5px]\"><span class=\"block w-[10px] h-[10px] rounded-full bg-purple-500\"></span><span class=\"block text-sm\"> Campaign Budget </span></div><h3 class=\"mb-0 leading-none text-[20px]\">$3200</h3></div><div><div class=\"flex items-center gap-[5px] mb-[5px]\"><span class=\"block w-[10px] h-[10px] rounded-full bg-orange-400\"></span><span class=\"block text-sm\"> Followers Goal </span></div><h3 class=\"mb-0 leading-none text-[20px]\">140,000</h3></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "area",
                height: "149",
                options: _ctx.instagramCampaigns,
                series: _ctx.campaigns
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}